"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getRef(parent, url, root) {
    // currentContext = currentContext || this.schema;
    var turl = url.split('/');
    var start = 0;
    if (turl[0] === '#') {
        if (root === undefined) {
            // szukaj łażąc po parentach
            while (parent.$parent) {
                parent = parent.$parent;
            }
        }
        else {
            parent = root;
        }
        start++;
    }
    else if (turl[0] === '.') {
        if (parent.$parent) {
            parent = parent.$parent;
        }
        start++;
    }
    else {
        // coś tam innego
        if (parent.$parent) {
            parent = parent.$parent;
        }
    }
    // let turl = url.split("/");
    var sparent2;
    for (var i = start; i < turl.length; i++) {
        sparent2 = parent;
        if (turl[i]) {
            if (turl[i] === '..') {
                parent = parent.$parent;
            }
            else {
                parent = parent[turl[i]];
            }
            if (parent === undefined) {
                return null;
            }
        }
    }
    return parent;
}
exports.fixSchemaDefaultOptions = {
    arrayItemGuidField: null,
    model: null
};
var refRegex = /{{([a-z.\[\]\s\?\"\'\:\(\)\+]*)}}/gim;
function isInDefinition(field) {
    var parent = field.$parent;
    if (field.$key === 'definitions') {
        if (parent && (parent.type === 'object' || parent.properties)) {
            return true;
        }
    }
    if (parent) {
        return isInDefinition(parent);
    }
    return false;
}
/**
 * Naprawia i łączy schematy
 * @param schemas schematy werjściowe
 * @param options opcje
 * @param parent element nadrzędny
 * @param root element root
 * @param mykey nazwa pola
 * @param fixType czy ma naprawiać typ pola jeśli brakuje
 */
function fixAndMergeSchema(schemas, options, parent, root, mykey, fixType) {
    if (options === void 0) { options = exports.fixSchemaDefaultOptions; }
    var props = {};
    var result = {};
    Object.defineProperty(result, '$key', {
        value: mykey || null
    });
    Object.defineProperty(result, '$parent', {
        value: parent || null
    });
    if (root === undefined || root === null) {
        root = result;
    }
    /*
      if (mykey === 'definitions') {
          if (parent && (parent.type == 'object' || parent.properties) && schemas.length == 1) {
              return schemas[0];
          }
      }
      */
    var i = 0;
    while (i < schemas.length) {
        var schema = schemas[i];
        // while (true) {
        // rozwiązywanie allof w bieacym schemacie
        // allof
        var allOf = schema.allOf;
        if (allOf !== undefined) {
            var dschemas = [];
            // wszystkie schemas do tej pory
            for (var ii = 0; ii < i; ii++) {
                dschemas.push(schemas[ii]);
            }
            // moja schema
            dschemas.push(schema);
            // z allof
            // tslint:disable-next-line: prefer-for-of
            for (var ii = 0; ii < allOf.length; ii++) {
                dschemas.push(allOf[ii]);
            }
            // wszystkie pozostałe schemas
            for (var ii = i + 1; ii < schemas.length; ii++) {
                dschemas.push(schemas[ii]);
            }
            schemas = dschemas;
            schema = schemas[i];
        }
        // $ref
        var $ref = schema.$ref;
        if ($ref !== undefined) {
            if ($ref.indexOf('{{') > -1) {
                $ref = $ref.replace(refRegex, function (match, fielddName) {
                    if (!options.model) {
                        return '';
                    }
                    var funct = 'with(model) {return ' + fielddName + '}';
                    var func = new Function('model', funct);
                    try {
                        return func(options.model);
                    }
                    catch (err) {
                        if (process.env.NODE_ENV === 'development') {
                            console.error("[DEBUG] cannot calc $ref by " + fielddName, err);
                            debugger;
                        }
                        return '';
                    }
                });
            }
            var refValue = getRef(result, $ref, root);
            if (refValue !== null) {
                schemas[i] = schema = refValue;
            }
        }
        // } else {
        //    break;
        // }
        // }
        for (var _i = 0, _a = Object.keys(schema); _i < _a.length; _i++) {
            var key = _a[_i];
            if (key === 'allOf') {
                continue;
            }
            var keyvalue = schema[key];
            if (keyvalue === null) {
                if (key !== 'default' && i > 0) {
                    delete props[key];
                    delete result[key];
                }
                else {
                    result[key] = null;
                }
            }
            else {
                if (Array.isArray(keyvalue)) {
                    if (result[key] !== undefined && key === 'required') {
                        // łącz array
                        var darray = result[key].slice();
                        // tslint:disable-next-line: prefer-for-of
                        for (var ii = 0; ii < keyvalue.length; ii++) {
                            var avalue = keyvalue[ii];
                            if (darray.indexOf(avalue) === -1) {
                                darray.push(avalue);
                            }
                        }
                        result[key] = darray;
                    }
                    else {
                        result[key] = keyvalue;
                    }
                }
                else if (typeof keyvalue === 'object') {
                    var proparray = props[key];
                    if (proparray === undefined) {
                        props[key] = proparray = [keyvalue];
                    }
                    else {
                        proparray.push(keyvalue);
                    }
                }
                else {
                    result[key] = keyvalue;
                }
            }
        }
        i++;
    }
    if (result.type === undefined) {
        if (fixType === true || fixType === undefined)
            if (props.properties !== undefined) {
                result.type = 'object';
            }
            else if (props.items !== undefined) {
                result.type = 'array';
            }
            else {
                // chodzi o to zeby nie dawało do enumeratora domyślnego typu, przydatne przy allOf
                Object.defineProperty(result, 'type', {
                    value: 'string'
                });
            }
        /*
            else if (!isInDefinition(result)) {
    
                result.type = 'string';
    
    
    
            }
            */
    }
    else if (result.type === 'int') {
        result.type = 'integer';
    }
    // fix guid field in array items
    /*
      if ((parent && parent.type === 'object') && (parent.$parent && parent.$parent.type === 'array')) {
  
      }
      */
    // dołaczanie wszystkich property
    // let propsCache: any = {};
    var fixChildType = mykey !== undefined && mykey === 'properties';
    if (false) {
        var newprops = {};
        var keys = Object.keys(props);
        var _loop_1 = function (key) {
            var cached;
            newprops[key] = {
                enumerable: true,
                configurable: true,
                get: function () {
                    if (cached) {
                        // console.log('schema cached property', key);
                        return cached;
                    }
                    else {
                        // console.log('schema get property', key);
                        return (cached = fixAndMergeSchema(props[key], options, result, root, key, fixChildType || key === 'items'));
                    }
                }
            };
        };
        for (var _b = 0, keys_1 = keys; _b < keys_1.length; _b++) {
            var key = keys_1[_b];
            _loop_1(key);
        }
        Object.defineProperties(result, newprops);
    }
    else {
        // const cached2: any = {};
        var keys = Object.keys(props);
        var _loop_2 = function (key) {
            var cached;
            Object.defineProperty(result, key, {
                enumerable: true,
                configurable: true,
                get: function () {
                    // delete result[key];
                    // return result[key] =
                    //   fixAndMergeSchema(props[key], options, result, root, key, fixChildType || (key === 'items'));
                    return (cached ||
                        (cached = fixAndMergeSchema(props[key], options, result, root, key, fixChildType || key === 'items')));
                    if (cached) {
                        // console.log('schema cached property', key);
                        return cached;
                    }
                    else {
                        // console.log('schema get property', key);
                        return (cached = fixAndMergeSchema(props[key], options, result, root, key, fixChildType || key === 'items'));
                    }
                }
            });
        };
        for (var _c = 0, keys_2 = keys; _c < keys_2.length; _c++) {
            var key = keys_2[_c];
            _loop_2(key);
        }
    }
    if (result.type === 'object' && parent && parent.type === 'array' && options.arrayItemGuidField) {
        var pp_1 = result.properties;
        if (pp_1 && pp_1[options.arrayItemGuidField] === undefined) {
            var cached_1;
            Object.defineProperty(pp_1, options.arrayItemGuidField, {
                enumerable: true,
                configurable: true,
                get: function () {
                    if (cached_1) {
                        // console.log('schema cached property', key);
                        return cached_1;
                    }
                    else {
                        // console.log('schema get property', key);
                        return (cached_1 = fixAndMergeSchema([
                            {
                                type: 'string',
                                format: 'guid'
                            }
                        ], options, pp_1, root, options.arrayItemGuidField, false));
                    }
                }
            });
            /*
                          pp[fixSchemaOptions.arrayItemGuidField] = {
                            type: 'string',
                            format: 'guid'
                          };
                          */
        }
    }
    return result;
}
exports.default = fixAndMergeSchema;
//# sourceMappingURL=fixAndMergeSchema.js.map